import React, { Component } from 'react';
import '../less/index.less'
import img5 from '../images/img5.png'

class Home extends Component {
    render() {
        return (
            <div className="home">
                <div className="title">
                    <span className="verticalLine"></span>
                    <span>产品服务</span>
                    <span className="verticalLine"></span>
                    <span>Product service</span>
                </div>
                <div className="ProductImages">
                    <div className="ProductImage img1" 
					>
                        <p className="title1">同城快递</p>
                        <p>满足商业用户</p>
                        <p>当日送的各种需求</p>
                    </div>
                    <div className="ProductImage img2" 
					>
                        <p className="title1">及时送</p>
                        <p>满足客户特殊</p>
                        <p>紧急的快递配送</p>
                    </div>
                    <div className="ProductImage img3" 
					>
                        <p className="title1">收发室</p>
                        <p>专为客户提供"收发一体"</p>
                        <p>的综合服务方案</p>
                    </div>
                    <div className="ProductImage img4" 
					>
                        <p className="title1">定制专属方案</p>
                        <p>专业专属方案</p>
                        <p>客户提供定制化专属方案</p>
                    </div>
                </div>
                <div className="case">
                    <div className="caseTitle">
                        <div className="horizontaLine"></div>
                        <div style={{marginLeft:10,marginRight:10}}>收发室案例</div>
                        <div className="horizontaLine"></div>
                    </div>
                    <div className="caseImage">
                        <div className="caseImage1">
                            <img src={img5} /><img src={img5} /><img src={img5} />
                        </div>
                        <div className="caseImage2">
                            <img src={img5} /><img src={img5} /><img src={img5} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Home;